'use client';

import { RuntimeFlag, useRuntimeFlag } from '@/shared/lib/analytics/flags';
import { useAuthStore } from '@/shared/stores/auth-store';

export interface WhatsNewGate {
  /** Signed-in subscriber — the only audience for v1. */
  eligibleUser: boolean;
  /** Flag state is known (resolved in PostHog, or local dev). */
  decided: boolean;
  /** Surfaces may fetch and render. */
  enabled: boolean;
}

const IS_DEV = process.env.NODE_ENV === 'development';

/**
 * Single gate for every What's New surface (popup host, rail dot, page).
 * PostHog is disabled in local dev, so an undefined flag counts as on there;
 * everywhere else undefined means "still loading or not targeted" → off.
 */
export function useWhatsNewEnabled(): WhatsNewGate {
  const eligibleUser = useAuthStore((s) => s.isAuthenticated && s.isSubscribed && s.user !== null);
  const flag = useRuntimeFlag(RuntimeFlag.WHATS_NEW, { skip: !eligibleUser });
  const flagOn = flag === true || (flag === undefined && IS_DEV);
  return {
    eligibleUser,
    decided: flag !== undefined || IS_DEV,
    enabled: eligibleUser && flagOn,
  };
}
